import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useBrand } from "../../context/BrandContext";
import { Logo } from "./Logo";
import { NAV } from "./Header";

export const Footer = () => {
  const b = useBrand();
  return (
    <footer className="bg-[#F7F8FA] border-t border-slate-200" data-testid="site-footer">
      <div className="h-1.5 hazard opacity-80" />
      <div className="container-x py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-5 text-slate-600 text-sm leading-relaxed max-w-sm">{b.tagline}.</p>
          <div className="mt-6 flex flex-wrap gap-2 font-mono text-[11px] tracking-wider">
            <span className="px-2.5 py-1 border border-slate-300 text-slate-700" data-testid="footer-usdot">USDOT {b.usdot}</span>
            <span className="px-2.5 py-1 border border-slate-300 text-slate-700" data-testid="footer-mc">{b.mc}</span>
            <span className="px-2.5 py-1 border border-amber-500/40 text-brand-600">Licensed & Insured</span>
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-display uppercase tracking-wider text-slate-900 font-bold mb-4">Navigate</h4>
          <ul className="grid grid-cols-2 md:grid-cols-1 gap-2.5 text-sm">
            {[...NAV, { to: "/track", label: "Track Shipment" }, { to: "/register", label: "Register Shipment" }].map((n) => (
              <li key={n.to}><Link to={n.to} className="text-slate-600 hover:text-brand-600 transition-colors" data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>{n.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-display uppercase tracking-wider text-slate-900 font-bold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm text-slate-700">
            <li className="flex gap-3"><MapPin className="w-4 h-4 text-orange-600 mt-0.5 shrink-0" /><span data-testid="footer-address">{b.address_full}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 text-orange-600 mt-0.5 shrink-0" /><a href={`tel:${b.phone_tel}`} className="hover:text-brand-600" data-testid="footer-phone-link">{b.phone_display}</a></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 text-orange-600 mt-0.5 shrink-0" /><a href={`mailto:${b.email}`} className="hover:text-brand-600 break-all" data-testid="footer-email-link">{b.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="container-x py-6 flex flex-col sm:flex-row gap-2 justify-between text-xs text-slate-500 font-mono">
          <span>© {new Date().getFullYear()} {b.company}. All rights reserved.</span>
          <span>{b.website} · <Link to="/admin" className="hover:text-brand-600" data-testid="footer-staff-login">Staff login</Link></span>
        </div>
      </div>
    </footer>
  );
};
